// AUTO-GENERATED by scripts/gen-frontend-config.mjs at 2026-06-12T07:59:55.298Z.
// DO NOT EDIT MANUALLY — re-run deploy.sh to refresh from cdk-outputs.json.
// This file is gitignored.
export interface AwsRuntimeConfig {
  readonly region: string;
  readonly apiBase: string;
  readonly wsUrl: string;
  readonly userPoolId: string;
  readonly userPoolClientId: string;
  readonly cloudFrontUrl: string;
}

export const awsConfig: AwsRuntimeConfig = {
  region: "us-east-1",
  apiBase: "/api",
  wsUrl: "wss://ia1n7lf971.execute-api.us-east-1.amazonaws.com/prod",
  userPoolId: "us-east-1_L6XrQGsD4",
  userPoolClientId: "117ajq7sfhtp0malt957fdj5ad",
  cloudFrontUrl: "https://health.seandall.com",
};
